import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, watch, ref } from 'vue'
import { useRoute } from 'vue-router'
import UdcTabbedSelect from '@/components/common/UdcTabbedSelect.vue'
import { useInitDataStore } from '@/stores/initDataStore'


export default /*#__PURE__*/_defineComponent({
  emits: ['select'],
  setup(__props, { emit }) {


const route = useRoute()
const initDataStore = useInitDataStore()
const defaults = ref({
  tabIndex: 0,
  listItemIndex: 0,
  itemIndex: 0,
})

const definitionInfo = computed(() => {
  return initDataStore.initData.definitionInfo?.graph.common.listItems
})

const tabs = computed(() => {
  return definitionInfo.value.items
})

const select = ({ tabIndex, listItemIndex, itemIndex }) => {
  const item = tabs.value[tabIndex].items[listItemIndex].items[itemIndex]

  emit('select', item)
}

watch(
  () => route.query.type,
  _type => {
    const type = _type || ''
    const [target] = (type as string).split('_')

    if (!target) {
      return
    }

    let tabIndex = 0
    const listItemIndex = 0
    const itemIndex = 0

    if (target === 'weather') {
      tabIndex = 1
    }

    const selected = { tabIndex, listItemIndex, itemIndex }
    defaults.value = selected
    select(selected)
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UdcTabbedSelect, {
    onSelect: select,
    title: _unref(definitionInfo).title,
    tabs: _unref(tabs),
    defaults: defaults.value
  }, null, 8, ["title", "tabs", "defaults"]))
}
}

})